export const LoadingSpinner = () => {
    return (
        <div className="flex flex-1 items-center justify-center">
            <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-400 rounded-full animate-spin"></div>
        </div>

    )
}
